import { Notification } from 'components/Notification';
import { ContentWrapper } from 'components/layout';
import { useCreateLocale } from 'api/localeApi';
import { LocaleForm } from './components';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PATH_NAME } from 'constants/routes';

export default function AddLocale() {
  const intl = useIntl();
  const navigate = useNavigate();
  const createMutation = useCreateLocale();

  const handleSubmit = (values) => {
    createMutation.mutate(values, {
      onSuccess(response) {
        Notification(
          'success',
          intl.formatMessage({
            id: `message.createSuccess`,
          }),
        );

        navigate(`/${PATH_NAME.LOCALES}/${response.id}`);
      },
      onError(error) {
        Notification(
          'error',
          error.message ?? intl.formatMessage({ id: 'message.commonError' }),
        );
      },
    });
  };

  return (
    <ContentWrapper title="Tạo mới">
      <LocaleForm
        onSubmit={handleSubmit}
        isLoading={createMutation.isLoading}
      />
    </ContentWrapper>
  );
}
